require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/analytics/legacy/framework/anly-colorama.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/analytics/legacy/framework/anly-colorama.legacy.js
// module id = 769
// module chunks = 31